module.exports = __webpack_public_path__ + "img/image-9.41604f5b.jpg";